// import { useMapStore } from "@/store/modules/map"
import appConfig from "@/modules/appConfig"
import { getModules } from "./arcgisAPI"
import appEnum from "./appEnum"

// const mapStore = useMapStore()

export async function getLayerModule(data: any): Promise<any> {
  let module: any = null
  switch (data.layerType) {
    // MapImageLayer-0
    case appEnum.MapImage:
      ;[module] = await getModules(["esri/layers/MapImageLayer"])
      break
    // FeatureLayer-1
    case appEnum.Feature:
      ;[module] = await getModules(["esri/layers/FeatureLayer"])
      break
    // BuildingSceneLayer-2
    case appEnum.BuildingScene:
      ;[module] = await getModules(["esri/layers/BuildingSceneLayer"])
      break
    // SceneLayer-3
    case appEnum.Scene:
      ;[module] = await getModules(["esri/layers/SceneLayer"])
      break
    // ElavationLayer-4
    case appEnum.Elevation:
      ;[module] = await getModules(["esri/layers/ElevationLayer"])
      break
    // ImageryTileLayer-5
    case appEnum.ImageryTile:
      ;[module] = await getModules(["esri/layers/ImageryTileLayer"])
      break
    // IntegratedMeshLayer-6
    case appEnum.IntegratedMesh:
      ;[module] = await getModules(["esri/layers/IntegratedMeshLayer"])
      break
    // TileLayer-7
    case appEnum.Tile:
      ;[module] = await getModules(["esri/layers/TileLayer"])
      break
    // WebTileLayer-8
    case appEnum.WebTile:
      ;[module] = await getModules(["esri/layers/WebTileLayer"])
      break
    // WMTSLayer-9
    case appEnum.WMTS:
      ;[module] = await getModules(["esri/layers/WMTSLayer"])
      break
    // WMSLayer-10
    case appEnum.WMS:
      ;[module] = await getModules(["esri/layers/WMSLayer"])
      break
    // ImageryLayer-11
    case appEnum.Imagery:
      ;[module] = await getModules(["esri/layers/ImageryLayer"])
      break
    // WFSLayer-12
    case appEnum.WFS:
      ;[module] = await getModules(["esri/layers/WFSLayer"])
      break
  }
  return module
}

// 创建图层
export async function createLayer(data: any) {
  try {
    let layer = null
    const options: any = {
      url: data.serviceUrl,
      outFields: ["*"]
      // spatialReference: config.spatialReference
    }
    const Layer = await getLayerModule(data)
    switch (data.layerType) {
      case appEnum.MapImage:
        // eslint-disable-next-line no-case-declarations
        const index = data.serviceUrl.lastIndexOf("/")
        // eslint-disable-next-line no-case-declarations
        const id = data.serviceUrl.substring(index + 1, data.serviceUrl.length)
        if (!isNaN(parseInt(id))) {
          layer = new Layer({
            url: data.serviceUrl.substring(0, index),
            sublayers: [
              {
                id: parseInt(id),
                visible: true
              }
            ]
          })
        } else {
          layer = new Layer({
            url: data.serviceUrl
          })
        }
        break
      case appEnum.Tile:
        options.version = 10.5
        layer = new Layer(options)
        break
      case appEnum.WebTile:
        if (appConfig.mapInitParam) {
          const mapInitParam: any = appConfig.mapInitParam
          const spatialReference = eval("(" + mapInitParam.mapConfig?.spatialReference + ")")
          let constraints = null
          if (mapInitParam.constraint && mapInitParam.constraint !== "") {
            constraints = eval("(" + mapInitParam.constraint + ")")
          }
          const tileInfo = {
            // eslint-disable-next-line @typescript-eslint/no-loss-of-precision
            dpi: 90.71428571427429,
            rows: 256,
            cols: 256,
            compressionQuality: 0,
            origin: {
              x: -180,
              y: 90
            },
            spatialReference,
            lods: constraints ? constraints.lods : []
          }
          layer = new Layer({
            urlTemplate: data.serviceUrl,
            tileInfo,
            spatialReference: tileInfo.spatialReference,
            fullExtent: {
              xmin: -180,
              ymin: -90,
              xmax: 180,
              ymax: 90,
              spatialReference
            },
            getTileUrl(level: any, row: any, col: any) {
              return this.urlTemplate
                .replace("{level}", length === 10 ? level : level + 1)
                .replace("{row}", row)
                .replace("{col}", col)
            }
          })
        } else {
          layer = new Layer({
            urlTemplate: data.serviceUrl,
            getTileUrl(level: any, row: any, col: any) {
              return this.urlTemplate
                .replace("{level}", length === 10 ? level : level + 1)
                .replace("{row}", row)
                .replace("{col}", col)
            }
          })
        }
        break
      case appEnum.Scene:
        layer = new Layer({ url: options.url })
        break
      default:
        layer = new Layer(options)
        break
    }
    layer.serviceUrl = data.serviceUrl
    layer.id = data.id
    layer.title = data.displayName
    layer.opacity = data.opacity ? data.opacity / 100 : 1
    layer.dataType = data.layerType
    if ("checked" in data) {
      layer.visible = data.checked
    }
    if (layer.visible) {
      layer.visible = data.visible
    }

    return layer
  } catch (error) {
    console.log(error)
    return null
  }
}

// 图层目录处理
export function getLayerTreeData(datas: any) {
  for (const i in datas) {
    const data = datas[i]
    if (data.children && data.children.length > 0) {
      getLayerTreeData(data.children)
    }
    if (data.layers && data.layers.length > 0) {
      const items = data.layers
      for (let k = 0; k < items.length; ++k) {
        const item = items[k]
        item.layerItemId = item.id
        try {
          item.id = item.name + "@" + item.mapLayer.id
          item.nodeId = item.name + "@" + item.mapLayer.id
          item.layerType = item.mapLayer.layerConfig.layerType
          item.serviceUrl = item.mapLayer.serviceUrl
        } catch (e) {
          console.log(e)
        }
      }
      if (data.children) {
        data.children = data.children.concat(items)
      } else {
        data.children = items
      }
      data.disabled = false
    } else if (data.layers && data.layers.length === 0) {
      data.disabled = true
    }
  }
  return datas
}
